var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75917 11.704L2.70268 6.75336C2.59276 6.64574 2.51508 6.52915 2.46964 6.40359C2.42347 6.27803 2.40039 6.1435 2.40039 6C2.40039 5.8565 2.42347 5.72197 2.46964 5.59641C2.51508 5.47085 2.59276 5.35426 2.70268 5.24664L7.75917 0.295964C7.9607 0.0986543 8.21718 0 8.52863 0C8.84009 0 9.09657 0.0986543 9.2981 0.295964C9.49963 0.493273 9.60039 0.744394 9.60039 1.04933C9.60039 1.35426 9.49963 1.60538 9.2981 1.80269L5.01108 6L9.2981 10.1973C9.49963 10.3946 9.60039 10.6457 9.60039 10.9507C9.60039 11.2556 9.49963 11.5067 9.2981 11.704C9.09657 11.9013 8.84009 12 8.52863 12C8.21718 12 7.9607 11.9013 7.75917 11.704Z",
    fill: "#2D2F35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.db458343ae2f0fff3e571415dc177623.svg";
export { ForwardRef as ReactComponent };